<ng-container *ngIf="isEmbedded; else contactDepartmentsPage">
  <div *ngIf="isEmbedded" class="padded">
    <mat-toolbar><mat-icon>business_center</mat-icon> Departments</mat-toolbar>

    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a routerLink="/contactCompanies/departments/{{companyId}}/{{contactCompanyId}}/{{element.id}}"
             [queryParams]="{embedded:true}">
            {{element.name}}
        </a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator #paginator
                   (page)="reload()">
    </mat-paginator>

    <div class="padded">
      <button mat-raised-button class="primary" routerLink="/contactCompanies/departments/{{companyId}}/{{contactCompanyId}}/0" [queryParams]="{embedded:true}">
        <mat-icon aria-label="Create a new contactDepartment">business_center</mat-icon>
        Create a new Department
      </button>
    </div>
  </div>
</ng-container>

<ng-template #contactDepartmentsPage>
  <div class="stick-top">
    <mat-toolbar><mat-icon>business_center</mat-icon> Contact Departments</mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary"
              [routerLink]="['/contactDepartments/'+(companyId ? companyId : '')+'/0']">
        <mat-icon aria-label="Create a new contact department">business_center</mat-icon>
        Create a new Contact Department
      </button>
    </div>
  </div>

  <div class="padded">
    <table class="basicTable">
      <thead>
      <tr>
        <th *ngIf="isCompanyAdmin && !isEmbedded">
          <div class="vbox">
            Company
            <micro-company-select [(companyId)]="filter.companyId">
            </micro-company-select>
          </div>
        </th>
        <th>
          <div class="vbox">
            Contact Company
            <micro-contactCompany-select [companyId]="filter.companyId" [(contactCompanyId)]="filter.contactCompanyId" [jump]="false">
            </micro-contactCompany-select>
          </div>
        </th>
        <th>
          <div class="vbox">
            Department
            <input [(ngModel)]="filter.name">
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td>
          <micro-company-lookup [companyId]="element.companyId"></micro-company-lookup>
        </td>
        <td>
          <micro-contactCompany-lookup [contactCompanyId]="element.contactCompanyId"></micro-contactCompany-lookup>
        </td>
        <td>
          <a routerLink="/contactDepartments/{{element.companyId}}/{{element.id}}">{{element.name}}</a>
        </td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="100">
          <mat-paginator #paginator
                         (page)="reload()">
          </mat-paginator>
        </td>
      </tr>
      </tfoot>
    </table>
  </div>
</ng-template>
